import { RssFeed } from '@oh-vcp/components-common';
import { useQuery } from 'react-query';
import apiService from './apiService';

const fetchRssFeed = async (feedType: string): Promise<RssFeed | null> => {
  const response = await apiService.get(
    `rss20?url=https%3A%2F%2Fotnhub.ca%2Ffeed%3Fpost_type%3D${feedType}`,
    {
      ignoreError: true
    }
  );

  if (response && response.data) {
    return response.data;
  }
  return null;
};

const useRssFeed = (feedType: string) => {
  return useQuery({
    queryFn: () => fetchRssFeed(feedType),
    queryKey: ['useRssFeed', feedType]
  });
};

export default useRssFeed;
